import axios from 'axios';

const api = axios.create({
  baseURL: 'https://jf.mcmvinscricao.com.br/api', // URL do seu backend Laravel
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para adicionar token nas requisições
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;